import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header, Sidebar } from '@widgets';
import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material';

const useStyles = makeStyles<Theme>((theme) => ({
  main: {
    height: '100%',
    color: theme.palette.text.primary,
    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.drawerWidth,
    },
  },
  content: {
    padding: theme.spacing(3),
  },
  loadingWrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export const AppLayout = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const classes = useStyles();

  return (
    <>
      <Sidebar open={drawerOpen} openDrawer={() => setDrawerOpen(true)} closeDrawer={() => setDrawerOpen(false)} />
      <main className={classes.main}>
        <Header onToggleDrawer={() => setDrawerOpen((prev) => !prev)} />
        <div className={classes.content}>
          <Outlet />
        </div>
      </main>
    </>
  );
};
